/* Confluence photo-first swatches 2026-10-18. Approved product color precedes photo estimate. */
(()=>{'use strict';
const selector='[data-cf-photo-swatch-hex],[data-cf-photo-swatch-src]',cache=new Map(),queue=[];
let active=0,watcher,scheduled=false;
// photo-estimate-guard-v2-20261018: reject photo guesses that contradict the named primary upper color.
function plausible(name,hex){
 const first=(name||'').trim().toLowerCase().split('/')[0].trim();
 const r=parseInt(hex.slice(1,3),16),g=parseInt(hex.slice(3,5),16),b=parseInt(hex.slice(5,7),16);
 const lum=0.2126*r+0.7152*g+0.0722*b, spread=Math.max(r,g,b)-Math.min(r,g,b);
 if(/^(white|off white|ivory|cream|coconut|pearl|chalk|bone|egret|star white)$/.test(first))return lum>=157&&spread<=85;
 if(/^(black|ebony|jet|triple black)$/.test(first))return lum<=125;
 if(/^(grey|gray|slate|steel|charcoal|graphite)$/.test(first))return lum>=40&&lum<=224&&spread<=85;
 if(/^(navy|midnight|deep navy)$/.test(first))return lum<=160&&b>=r-20;
 if(/^(blue|sky blue|light blue|baby blue|ocean blue)$/.test(first))return b>=r-15&&b>=g-22;
 return true;
}
function paint(el,hex,source){
  if(!/^#[0-9a-fA-F]{6}$/.test(hex||''))return;
  if(source==='photo-estimate'&&!plausible(el.dataset.swatch,hex)){
    el.dataset.cfPhotoSwatchResult='photo-rejected-color-mismatch';
    return;
  }
  el.style.setProperty('--swatch-background-color',hex,'important');
  el.style.setProperty('--swatch-background-image','none','important');
  el.dataset.cfPhotoSwatchResult=source;
}
function representative(img){
 const w=96,canvas=document.createElement('canvas');canvas.width=w;canvas.height=w;
 const ctx=canvas.getContext('2d',{willReadFrequently:true});if(!ctx)return null;
 ctx.drawImage(img,0,0,w,w);
 const d=ctx.getImageData(0,0,w,w).data,bins=new Map();
 let count=0;
 for(let y=24;y<74;y+=2)for(let x=11;x<90;x+=2){
  const k=(y*w+x)*4,r=d[k],g=d[k+1],b=d[k+2],hi=Math.max(r,g,b),lo=Math.min(r,g,b);
  if(d[k+3]<225||(hi>=235&&hi-lo<14)||hi<18)continue;
  const key=[r>>4,g>>4,b>>4].join('-'),weight=(y<60?1.3:1)*(x>23&&x<80?1.2:1);
  const v=bins.get(key)||{w:0,r:0,g:0,b:0};
  v.w+=weight;v.r+=r*weight;v.g+=g*weight;v.b+=b*weight;bins.set(key,v);count++;
 }
 if(count<30)return null;
 const binsSorted=[...bins.values()].sort((a,b)=>b.w-a.w),a=binsSorted[0];
 const ar=a.r/a.w,ag=a.g/a.w,ab=a.b/a.w;
 let weight=0,rr=0,gg=0,bb=0;
 binsSorted.forEach(v=>{
  const dist=Math.hypot(v.r/v.w-ar,v.g/v.w-ag,v.b/v.w-ab);
  if(dist>52)return;
  weight+=v.w;rr+=v.r;gg+=v.g;bb+=v.b;
 });
 if(!weight)return null;
 return '#'+[rr/weight,gg/weight,bb/weight].map(n=>Math.round(n).toString(16).padStart(2,'0')).join('').toUpperCase();
}
function pump(){
 while(active<4&&queue.length){
  const el=queue.shift(),url=el.dataset.cfPhotoSwatchSrc;
  if(!url)continue;
  if(cache.has(url)){if(cache.get(url))paint(el,cache.get(url),'photo-estimate');continue}
  active++;
  const img=new Image();img.crossOrigin='anonymous';
  img.onload=()=>{let hex=null;try{hex=representative(img)}catch(e){}cache.set(url,hex||false);if(hex)paint(el,hex,'photo-estimate');active--;pump()};
  img.onerror=()=>{cache.set(url,false);active--;pump()};
  img.src=url;
 }
}
function apply(el){
 if(el.dataset.cfPhotoSwatchQueued)return;
 el.dataset.cfPhotoSwatchQueued='1';
 if(el.dataset.cfPhotoSwatchHex){paint(el,el.dataset.cfPhotoSwatchHex,'approved');return}
 if(el.dataset.cfPhotoSwatchSrc){queue.push(el);pump()}
}
function watch(el){
 if(el.dataset.cfPhotoSwatchQueued||el.dataset.cfPhotoSwatchObserved)return;
 el.dataset.cfPhotoSwatchObserved='1';
 if(watcher)watcher.observe(el);else apply(el);
}
function scan(root){
 if(root.matches&&root.matches(selector))watch(root);
 if(root.querySelectorAll)root.querySelectorAll(selector).forEach(watch);
}
function start(){
 if('IntersectionObserver'in window)watcher=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){watcher.unobserve(e.target);apply(e.target)}}),{rootMargin:'200px'});
 scan(document);
 new MutationObserver(list=>{if(scheduled||!list.some(x=>x.addedNodes.length))return;scheduled=true;setTimeout(()=>{scheduled=false;scan(document)},180)}).observe(document.body,{childList:true,subtree:true});
 document.addEventListener('shopify:section:load',e=>scan(e.target));
}
// In browser preview console: ConfluenceSwatchAudit.report().
window.ConfluenceSwatchAudit={report(){
 const nodes=[...document.querySelectorAll('[data-swatch]')];
 const records=nodes.map(el=>({color:el.dataset.swatch||'',method:el.dataset.cfPhotoSwatchResult||'name-fallback',hasPhoto:Boolean(el.dataset.cfPhotoSwatchSrc)}));
 const counts={};
 for(const row of records)counts[row.method]=(counts[row.method]||0)+1;
 return {swatches:records.length,methods:counts,needsReview:records.filter(x=>x.method==='name-fallback'||x.method==='photo-rejected-color-mismatch').map(x=>x.color),records};
}};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();